import locale from 'meta-ui/lib/locale/lang/zh-TW';
import zhHant from 'govmo-common/src/locales/zh-Hant.json';
import merge from 'lodash/merge';
import AddressComponent from 'common/components/Address/locales/zh-Hant.json';
import MessagePlugin from 'common/plugins/message/locales/zh-Hant.json';

export default {
  ...MessagePlugin,
  ...AddressComponent,
  ...merge(locale, {
    el: {
      transfer: {
        filterPlaceholder: '請輸入搜索內容',
      },
    },
  }),
  ...zhHant,
};
